import { CTA, FeatureLedger, Hero, Intro } from "../components/Section";
import { services } from "../content/site";
import { workImageSets } from "../content/workImages";

export function ServicesPage() {
  return (
    <>
      <Hero
        images={workImageSets.servicesHero}
        title="A service structure built to keep scope, tolerances, and handoff decisions legible."
        copy="Each engagement can be commissioned independently or assembled into a full delivery path, depending on where your team needs technical depth, fabrication capacity, or installation readiness."
        primary={{ label: "Request Review", href: "/contact" }}
      />
      <Intro
        eyebrow="Service Ledger"
        title="Fabrication support from early planning through field-ready delivery."
        copy="The process can start with a feasibility question or a complete drawing set. The goal is the same: reduce uncertainty before material is cut."
      />
      <FeatureLedger items={services} />
      <CTA
        title="Need a fabrication partner that can read the details and carry them through production?"
        copy="Share drawings, intent sketches, or an active bid package and we will outline where design assist, detailing, fabrication, or delivery support will make the biggest difference."
        label="Bring the Scope Into Review"
        href="/contact"
      />
    </>
  );
}
